import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import VideoManual from '../views/manual/VideoManual.vue';
import miniRoutes from './mini';
import svwRoutes from './svw';
import cqRoutes from './cq';
import avwRoutes from './avw';
import tikaRoutes from './tika';
import tikaAssistantRoutes from './tika-assistant';
import rhinosRoutes from './rhinos';
import lexusRoutes from './lexus';
import lxRoutes from './lx';
import slRoutes from './dpca';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/unlock-explain',
    name: 'unlockExplain',
    component: () => import('@/views/smart-lock/unlockExplain.vue')
  },
  {
    path: '/lock-explain',
    name: 'lockExplain',
    component: () => import('@/views/smart-lock/lockExplain.vue')
  },
  {
    path: '/question-one',
    name: 'questionOne',
    component: () => import('@/views/smart-lock/questionOne.vue')
  },
  {
    path: '/question-two',
    name: 'questionTwo',
    component: () => import('@/views/smart-lock/questionTwo.vue')
  },
  {
    path: '/question-three',
    name: 'questionThree',
    component: () => import('@/views/smart-lock/questionThree.vue')
  },
  {
    path: '/',
    name: 'home',
    component: VideoManual,
    meta: {
      passStore: true
    }
  },
  {
    // 用户手册（产品简介）
    path: '/appWebsite',
    name: 'appWebsite',
    component: VideoManual
  },
  {
    // 巴盾用户手册（产品简介）
    path: '/appWebsite_paton',
    name: 'appWebsitePaton',
    component: () => import('@/views/manual/VideoManualPT.vue')
  },
  {
    // 用户手册详情
    path: '/appWebsite/showVideo/:title?',
    name: 'appWebsite-showVideo',
    meta: {
      passStore: true
    },
    component: () =>
      import(/* webpackChunkName: "VManualDetail" */ '@/views/manual/VManualDetail.vue')
  },
  {
    // 用户手册详情--巴盾
    path: '/appWebsite_paton/showVideo',
    name: 'appWebsite_paton-showVideo',
    component: () =>
      import(/* webpackChunkName: "VManualDetail" */ '@/views/manual/VManualDetail.vue')
  },
  // 广丰小程序用户指南
  {
    path: '/gfMiniprogramUserManual',
    name: 'gfMiniprogramUserManual',
    component: () =>
      import(/* webpackChunkName: "VManualDetailGF" */ '@/views/manual/VManualDetailGF.vue'),
    meta: {
      cname: '广丰小程序用户手册'
    }
  },

  /**
   * 智能解闭锁用户手册（使用指南）
   * 新版智能锁地址，采用url区分不同的app
   */
  //
  {
    path: '/intelligent-unlocking/:app',
    name: 'intelligentUnlockingWithApp',
    component: () =>
      import(/* webpackChunkName: "SmartLockerManual" */ '@/views/manual/SmartLockerManual.vue'),
    meta: {
      cname: '智能解闭锁'
    },
    props: true
  },

  // 智能解闭锁用户手册（使用指南）- 老版本，为了向前兼容
  {
    path: '/intelligent-unlocking',
    name: 'intelligentUnlocking',
    component: () =>
      import(/* webpackChunkName: "SmartLockerManual" */ '@/views/manual/SmartLockerManual.vue'),
    meta: {
      cname: '智能解闭锁'
    }
  },
  // 新手说明
  {
    path: '/novice-instructions',
    name: 'noviceInstructions',
    component: () =>
      import(/* webpackChunkName: "NormalManual" */ '@/views/manual/NormalManual.vue'),
    meta: {
      cname: '新手说明'
    }
  },
  // 新手说明-巴盾
  {
    path: '/novice-instructions/:app',
    name: 'noviceInstructionsNew',
    component: () =>
      import(/* webpackChunkName: "NormalManual" */ '@/views/manual/NormalManual.vue'),
    meta: {
      cname: '新手说明巴盾'
    },
    props: true
  },
  // 新手说明详情
  {
    path: '/novice-instructions/:app/detail',
    name: 'noviceInstructionsDetail',
    component: () => import(/* webpackChunkName: "Manual" */ '@/views/manual/ManualDetail.vue'),
    meta: {
      cname: '新手说明详情'
    },
    props: true
  },

  //-------------------------------------车型列表------------------------------------

  // 支持车型列表（乘趣）
  {
    path: '/carType',
    name: 'carType',
    component: () => import(/* webpackChunkName: "CarType" */ '@/views/car-type/CarType.vue'),
    meta: {
      cname: '车型'
    }
  },
  // 支持车型列表（巴盾）
  {
    path: '/carType_paton',
    name: 'carTypePaton',
    component: () => import(/* webpackChunkName: "CarType" */ '@/views/car-type/CarType.vue'),
    meta: {
      cname: '车型'
    }
  },

  // 车模
  {
    path: '/carModel',
    name: 'carModel',
    component: () => import(/* webpackChunkName: "CarModel" */ '@/views/car-model/CarModel.vue'),
    meta: {
      cname: '车模型'
    }
  },

  //-------------------------------------用户协议------------------------------------
  {
    // SDK内部隐私协议
    path: '/paLimit_sdk',
    name: 'paLimit_sdk',
    component: () => import(/* webpackChunkName: "migrationVW" */ '@/views/privacy/SdkPrivacy.vue')
  },

  {
    // 海外用户服务协议
    path: '/paRegist_overseas',
    name: 'paRegist_overseas',
    component: () =>
      import(/* webpackChunkName: "paRegist_oversea" */ '@/views/tika/AgreementsOversea.vue')
  },
  {
    // 用户服务协议,悠悠车主，对一丰项目支持的页面
    path: '/paRegist_yycz',
    name: 'paRegist_yycz',
    component: () =>
      import(/* webpackChunkName: "AgreementsYY" */ '@/views/yy/agreements/AgreementsYY.vue')
  },
  {
    // 用户服务协议广丰
    path: '/serviceAgreementGf',
    name: 'serviceAgreementGf',
    component: () =>
      import(/* webpackChunkName: "AgreementsGF" */ '@/views/gf/agreements/AgreementsGF.vue')
  },
  // 门店试用协议
  {
    path: '/userTrialAgreement',
    name: 'userTrialAgreement',
    component: () =>
      import(/* webpackChunkName: "AgreementsMD" */ '@/views/md/agreements/AgreementsMD.vue'),
    meta: {
      cname: '用户试用协议'
    }
  },

  //-------------------------------------隐私协议------------------------------------

  {
    // 隐私权保护政策
    path: '/paLimit',
    name: 'paLimit',
    component: () => import(/* webpackChunkName: "Privacy" */ '@/views/privacy/Privacy.vue')
  },
  {
    // 隐私权保护政策-海外
    path: '/paLimit_overseas',
    name: 'paLimit_overseas',
    component: () =>
      import(/* paLimit_overseas: "PrivacyOverseas" */ '@/views/privacy/PrivacyOverseas.vue')
  },
  {
    // 隐私权保护政策, 悠悠车主，对一丰项目支持的页面
    path: '/paLimit_yycz',
    name: 'paLimit_yycz',
    component: () => import(/* webpackChunkName: "PrivacyYY" */ '@/views/privacy/PrivacyYY.vue')
  },
  {
    // 隐私权保护政策--巴盾数钥
    path: '/paLimit_paton',
    name: 'paLimit_paton',
    component: () => import(/* webpackChunkName: "PrivacyPT" */ '@/views/privacy/PrivacyPT.vue')
  },
  {
    // 隐私权保护政策--广丰
    path: '/privacyPolicyGf',
    name: 'privacyPolicyGf',
    component: () => import(/* webpackChunkName: "PrivacyGF" */ '@/views/privacy/PrivacyGF.vue')
  },
  //--------------------------------------保养-----------------------------------
  {
    // 车辆保养
    path: '/maintenance',
    name: 'maintenance',
    component: () =>
      import(/* webpackChunkName: "MainTenance" */ '@/views/maintenance/MainTenance.vue'),
    meta: {
      cname: '车辆保养'
    }
  },
  //---------------------------------------客户服务（常见问题）----------------------------------

  {
    // 个人信息收集清单
    path: '/commonShare',
    name: 'commonShare',
    component: () =>
      import(/* webpackChunkName: "commonShare" */ '@/views/privacy/CommonShare.vue'),
    meta: {
      cname: '第三方信息共享清单'
    }
  },
  {
    // 功能更新
    path: '/funcList',
    name: 'funcList',
    component: () =>
      import(/* webpackChunkName: "funcList" */ '@/views/svw/functionList/index.vue'),
    meta: {
      cname: '功能更新'
    }
  },
  {
    // 功能更新
    path: '/funcListVW/moduleFunDetailVW',
    name: 'moduleFunDetailVW',
    component: () =>
      import(
        /* webpackChunkName: "moduleFunDetailVW" */ '@/views/svw/functionList/BeginnerVW/Detail.vue'
      ),
    meta: {
      cname: '功能更新'
    }
  },
  {
    // 功能详情页
    path: '/funcList/moduleFunDetail/:id',
    name: 'moduleFunDetail',
    component: () =>
      import(/* webpackChunkName: "funcList" */ '@/views/svw/functionList/moduleFunDetail.vue'),
    meta: {
      hideNavBar: 1,
      cname: '功能详情'
    }
  },
  {
    // 加入我们
    path: '/joinUs',
    name: 'joinUs',
    component: () => import(/* webpackChunkName: "JoinUs" */ '@/views/join-us/JoinUs.vue'),
    meta: {
      cname: '加入我们'
    }
  },
  {
    // 本田数字钥匙安装说明书
    path: '/honda/ins',
    name: 'hondaIns',
    component: () =>
      import(
        /* webpackChunkName: "hondaIns" */ '@/views/brand-building/honda/instruction/InstallBook.vue'
      ),
    meta: {
      cname: '本田数字钥匙安装指导'
    }
  },
  {
    // 本田数字钥匙安装说明书列表
    path: '/honda/ins/list',
    name: 'hondaInsList',
    component: () =>
      import(
        /* webpackChunkName: "hondaInsList" */ '@/views/brand-building/honda/instruction/BookList.vue'
      ),
    meta: {
      cname: '安装指导'
    }
  },
  {
    // 本田数字钥匙安装视频说明书
    path: '/honda/ins/video',
    name: 'hondaInsVideo',
    component: () =>
      import(
        /* webpackChunkName: "hondaInsVideo" */ '@/views/brand-building/honda/instruction/BookVideo.vue'
      ),
    meta: {
      cname: '安装指导'
    }
  },
  {
    // 本田数字钥匙安装视频说明书
    path: '/honda/ins/pdf',
    name: 'hondaInsPdf',
    component: () =>
      import(
        /* webpackChunkName: "hondaInsPdf" */ '@/views/brand-building/honda/instruction/BookPdf.vue'
      ),
    meta: {
      cname: '本田数字钥匙安装视频说明书'
    }
  },
  {
    // 捷途数字钥匙安装说明书
    path: '/jetour/ins/list',
    name: 'jetourInsList',
    component: () =>
      import(
        /* webpackChunkName: "jetourInsList" */ '@/views/brand-building/jetour/instruction/BookList.vue'
      ),
    meta: {
      cname: '捷途数字钥匙安装视频说明书'
    }
  },
  {
    // 捷途数字钥匙安车型选择
    path: '/jetour/ins',
    name: 'jetourIns',
    component: () =>
      import(
        /* webpackChunkName: "jetourIns" */ '@/views/brand-building/jetour/instruction/InstallBook.vue'
      ),
    meta: {
      cname: 'Installation Guide for Jetour Digital Key'
    }
  },
  {
    // 捷途数字钥匙视频介绍
    path: '/jetour/ins/video',
    name: 'jetourInsVideo',
    component: () =>
      import(
        /* webpackChunkName: "jetourInsVideo" */ '@/views/brand-building/jetour/instruction/BookVideo.vue'
      ),
    meta: {
      cname: 'Installation Guide for Jetour Digital Key'
    }
  },
  {
    // 捷途数字钥匙视频介绍
    path: '/jetour/ins/pdf',
    name: 'jetourInsPdf',
    component: () =>
      import(
        /* webpackChunkName: "jetourInsPdf" */ '@/views/brand-building/jetour/instruction/BookPdf.vue'
      ),
    meta: {
      cname: 'Installation Guide for Jetour Digital Key'
    }
  },
  {
    // 本田宣发数字钥匙安装说明书
    path: '/hondaDis/ins',
    name: 'hondaDisIns',
    component: () =>
      import(
        /* webpackChunkName: "hondaDisIns" */ '@/views/brand-building/honda/dispersion/InstallBook.vue'
      ),
    meta: {
      cname: '本田数字钥匙安装指导'
    }
  },
  {
    // 本田数字钥匙安装说明书列表
    path: '/hondaDis/ins/list',
    name: 'hondaDisInsList',
    component: () =>
      import(
        /* webpackChunkName: "hondaDisInsList" */ '@/views/brand-building/honda/dispersion/BookList.vue'
      ),
    meta: {
      cname: '本田数字钥匙安装指导'
    }
  },
  {
    // 本田宣发钥匙安装视频说明书
    path: '/hondaDis/ins/video',
    name: 'hondaDisInsVideo',
    component: () =>
      import(
        /* webpackChunkName: "hondaDisInsVideo" */ '@/views/brand-building/honda/dispersion/BookVideo.vue'
      ),
    meta: {
      cname: '本田数字钥匙安装指导'
    }
  },
  {
    // 本田宣发钥匙安装视频说明书
    path: '/hondaDis/ins/pdf',
    name: 'hondaDisInsPdf',
    component: () =>
      import(
        /* webpackChunkName: "hondaDisInsPdf" */ '@/views/brand-building/honda/dispersion/BookPdf.vue'
      ),
    meta: {
      cname: '本田数字钥匙安装指导'
    }
  },
  {
    path: '/link',
    name: 'link',
    component: () => import(/* webpackChunkName: "link" */ '@/views/link/index.vue'),
    meta: {
      cname: 'link'
    }
  },
  {
    path: '/bill/pay',
    name: 'billPay',
    component: () => import(/* webpackChunkName: "billPay" */ '@/views/bill/index.vue'),
    meta: {
      cname: 'link'
    }
  },
];
const catch404Route = {
  path: '*',
  name: 'notFoundFallback',
  component: () => import(/* webpackChunkName: "NotFound" */ '@/views/common/NotFound.vue')
};
const finalRoutes = routes.concat(
  miniRoutes,
  svwRoutes,
  avwRoutes,
  cqRoutes,
  tikaRoutes,
  tikaAssistantRoutes,
  rhinosRoutes,
  lexusRoutes,
  lxRoutes,
  slRoutes,
  // 兜底路由：任意未匹配的路径直接渲染 404 页面（保持原始 URL 不变），必须放在所有路由之后
  catch404Route
);
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: finalRoutes
});

export default router;
